import React from 'react';
import styled, { css, keyframes } from 'styled-components';

export const Progressbar = ({ height, background, ...rest }) => (
  <Container height={height} background={background}>
    <Progress {...rest} />
  </Container>
);

const Container = styled.div`
  position: relative;
  height: ${({ height = '4px' }) => height};
  display: block;
  width: 100%;
  background-color: ${({ background = '#f5f9ff' }) => background};
  background-clip: padding-box;
  overflow: hidden;
`;

const Progress = styled.div`
  ${({ mode }) => {
    switch (mode) {
      case 'indeterminate':
        return css`
          background-color: ${({ color, theme }) => color || theme.colors.primary};
          &:before {
            content: '';
            position: absolute;
            background-color: inherit;
            top: 0;
            left: 0;
            bottom: 0;
            will-change: left, right;
            animation: ${indeterminate} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
          }
          &:after {
            content: '';
            position: absolute;
            background-color: inherit;
            top: 0;
            left: 0;
            bottom: 0;
            will-change: left, right;
            animation: ${indeterminate_short} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) infinite;
            animation-delay: 1.15s;
          }
        `;
      case 'determinate':
      default:
        return css`
          position: absolute;
          top: 0;
          bottom: 0;
          width: ${({ progress = '100%' }) => progress};
          background-color: ${({ color, theme }) => color || theme.colors.primary};
          transition: width 300ms linear;
        `;
    }
  }}
`;

const indeterminate = keyframes`
  0% {
    left: -35%;
    right: 100%;
  }
  60% {
    left: 100%;
    right: -90%;
  }
  100% {
    left: 100%;
    right: -90%;
  }
`;

const indeterminate_short = keyframes`
  0% {
    left: -200%;
    right: 100%;
  }
  60% {
    left: 107%;
    right: -8%;
  }
  100% {
    left: 107%;
    right: -8%;
  }
`;
